export enum AnalyticsEvents {
  ConnectVisit = 'Connect Visit',
  ConnectSignUp = 'Connect Sign Up',
  SignUpFail = 'Sign Up Fail',
  Login = 'Login',
  LoginFail = 'Login Fail',
  Logout = 'Logout',
  LocationSelected = 'Location Selected',
  CategorySelected = 'Category Selected',
  ServiceSelected = 'Service Selected',
  ClassSelected = 'Class Selected',
  DateSelected = 'Date Selected',
  AppointmentSelected = 'Appointment Selected',
  BookingMade = 'Booking Made',
  AppointmentTimeBackButton = 'Appointment Time Back Button',
  ChangeDate = 'AppointmentSelectScreenChangeDate',
  Previous = 'AppointmentSelectScreenPrevious',
  Next = 'AppointmentSelectScreenNext',
  NextAvailable = 'AppointmentSelectNextAvailable'
}

export const analyticsEventMapping: Record<AnalyticsEvents, { ga: string; june: string }> = {
  [AnalyticsEvents.ConnectVisit]: { ga: '', june: 'Connect Visit' },
  [AnalyticsEvents.ConnectSignUp]: { ga: 'sign_up', june: 'Connect Sign Up' },
  [AnalyticsEvents.SignUpFail]: { ga: 'sign_up_failed', june: 'Sign Up Fail' },
  [AnalyticsEvents.Login]: { ga: 'login', june: 'Login' },
  [AnalyticsEvents.LoginFail]: { ga: 'login_failed', june: 'Login Fail' },
  [AnalyticsEvents.Logout]: { ga: 'logout', june: 'Logout' },
  [AnalyticsEvents.LocationSelected]: { ga: 'location_selected', june: 'Location Selected' },
  [AnalyticsEvents.CategorySelected]: { ga: 'category_selected', june: 'Category Selected' },
  [AnalyticsEvents.ServiceSelected]: { ga: 'service_selected', june: 'Service Selected' },
  [AnalyticsEvents.ClassSelected]: { ga: 'class_selected', june: 'Class Selected' },
  [AnalyticsEvents.DateSelected]: { ga: 'date_selected', june: 'Date Selected' },
  [AnalyticsEvents.AppointmentSelected]: {
    ga: 'appointment_selected',
    june: 'Appointment Selected'
  },
  [AnalyticsEvents.BookingMade]: { ga: '', june: 'Booking Made' },
  [AnalyticsEvents.AppointmentTimeBackButton]: { ga: 'Appointment_Time_BackButton', june: '' },
  [AnalyticsEvents.ChangeDate]: { ga: 'AppointmentSelectScreenChangeDate', june: '' },
  [AnalyticsEvents.Previous]: { ga: 'AppointmentSelectScreenPrevious', june: '' },
  [AnalyticsEvents.Next]: { ga: 'AppointmentSelectScreenNext', june: '' },
  [AnalyticsEvents.NextAvailable]: { ga: 'AppointmentSelectNextAvailable', june: '' }
};
